export default Object.freeze({
  INVALID_CHECK_DIGIT: 'INVALID_CHECK_DIGIT',
  INVALID_INDICATOR_DIGIT: 'INVALID_INDICATOR_DIGIT',
  NON_NUMERIC: 'NON_NUMERIC',
  NOT_FOUND: 'NOT_FOUND',
  TOO_LONG: 'TOO_LONG',
  TOO_SHORT: 'TOO_SHORT'
})



// WEBPACK FOOTER //
// ./src/const/errors/index.js